export default __webpack_public_path__ + "b047ae2.png";